(function () {
    // Utility helpers
    function parseYMD(ymd) {
        if (!ymd) return null;
        if (ymd instanceof Date) return new Date(ymd.getFullYear(), ymd.getMonth(), ymd.getDate());
        var parts = ('' + ymd).split('-');
        if (parts.length < 3) return null;
        return new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
    }

    function formatYMD(date) {
        var y = date.getFullYear();
        var m = String(date.getMonth() + 1).padStart(2, '0');
        var d = String(date.getDate()).padStart(2, '0');
        return y + '-' + m + '-' + d;
    }

    function cloneDate(d) { return new Date(d.getFullYear(), d.getMonth(), d.getDate()); }
    function addDays(d, n) { var r = cloneDate(d); r.setDate(r.getDate() + n); return r; }
    function addMonths(d, n) {
        var r = new Date(d.getFullYear(), d.getMonth() + n, d.getDate());
        while (r.getMonth() !== ((d.getMonth() + n) % 12 + 12) % 12 && r.getDate() > 28) {
            r.setDate(r.getDate() - 1);
        }
        return r;
    }
    function daysInMonth(year, month) { return new Date(year, month + 1, 0).getDate(); }

    function expandRecurrences(events, startDate, endDate) {
        var occurrences = [];
        events.forEach(function (evt) {
            var baseDate = parseYMD(evt.date);
            if (!baseDate) return;

            // normalize recurrence fields
            var rec = (evt.recurrence || 'none').toLowerCase();
            var interval = Number(evt.recurrence_interval || 1) || 1;
            var weekdays = (evt.recurrence_weekdays || []).map(function (w) { return Number(w); });
            var recEnd = parseYMD(evt.recurrence_end_date);
            var recCount = Number(evt.recurrence_count || 0) || 0;

            // Parse recurrence exceptions (comma-separated dates or ranges)
            // Supported formats:
            //  - single date: "2025-12-24"
            //  - range using two dots: "2025-12-24..2025-12-26"
            //  - range using space-hyphen-space: "2025-12-24 - 2025-12-26"
            var exceptionsText = (evt.recurrence_exceptions || '') + '';
            var exceptionRanges = [];
            if (exceptionsText) {
                exceptionsText.split(',').forEach(function (part) {
                    var p = (part || '').trim();
                    if (!p) return;
                    var sepMatch = p.match(/\.\.+/); // '..' or '...'
                    if (sepMatch) {
                        var parts = p.split(sepMatch[0]).map(function (s) { return s.trim(); });
                        var a = parseYMD(parts[0]);
                        var b = parseYMD(parts[1]) || a;
                        if (a) exceptionRanges.push({ start: a, end: b });
                        return;
                    }
                    // support " - " clearly separated range (space hyphen space)
                    var dashMatch = p.match(/\s-\s/);
                    if (dashMatch) {
                        var parts2 = p.split(dashMatch[0]).map(function (s) { return s.trim(); });
                        var a2 = parseYMD(parts2[0]);
                        var b2 = parseYMD(parts2[1]) || a2;
                        if (a2) exceptionRanges.push({ start: a2, end: b2 });
                        return;
                    }
                    // fallback: try single date
                    var single = parseYMD(p);
                    if (single) exceptionRanges.push({ start: single, end: single });
                });
            }

            function isExceptionDate(d) {
                if (!exceptionRanges.length) return false;
                var ymd = formatYMD(d);
                for (var i = 0; i < exceptionRanges.length; i++) {
                    var r = exceptionRanges[i];
                    if (!r.start) continue;
                    var s = r.start;
                    var e = r.end || r.start;
                    // compare as date-only
                    if (formatYMD(s) <= ymd && ymd <= formatYMD(e)) return true;
                }
                return false;
            }

            function pushIfInRange(d, idx) {
                if (recEnd && d > recEnd) return false;
                if (recCount && idx >= recCount) return false;
                // skip exceptions but continue generating further occurrences
                if (isExceptionDate(d)) return true;
                if (d >= startDate && d <= endDate) {
                    occurrences.push(Object.assign({}, evt, { occurrence_date: formatYMD(d) }));
                }
                return true;
            }

            if (rec === 'none') {
                if (baseDate >= startDate && baseDate <= endDate && !isExceptionDate(baseDate)) {
                    occurrences.push(Object.assign({}, evt, { occurrence_date: formatYMD(baseDate) }));
                }
                return;
            }

            var count = 0;
            if (rec === 'daily') {
                var current = cloneDate(baseDate);
                if (current < startDate) {
                    var diff = Math.floor((startDate - current) / (1000 * 60 * 60 * 24));
                    var cyclesToSkip = Math.floor(diff / interval);
                    current = addDays(current, cyclesToSkip * interval);
                    while (current < startDate) current = addDays(current, interval);
                }
                while (current <= endDate) {
                    if (recEnd && current > recEnd) break;
                    if (recCount && count >= recCount) break;
                    if (!pushIfInRange(current, count)) break;
                    // only increment count when we actually added an occurrence (i.e. not an exception)
                    if (!isExceptionDate(current)) count++;
                    current = addDays(current, interval);
                }
            } else if (rec === 'weekly') {
                var weekdaysList = (weekdays && weekdays.length) ? weekdays.slice().sort() : [baseDate.getDay()];
                var ref = cloneDate(baseDate);
                ref.setHours(0, 0, 0, 0);
                var currentWeekStart = cloneDate(ref);
                while (addDays(currentWeekStart, 7 * interval) <= startDate) {
                    currentWeekStart = addDays(currentWeekStart, 7 * interval);
                }
                while (currentWeekStart > startDate) currentWeekStart = addDays(currentWeekStart, -7 * interval);

                var weekIndex = 0;
                var stop = false;
                while (!stop) {
                    weekdaysList.forEach(function (wd) {
                        if (stop) return;
                        var candidate = addDays(currentWeekStart, (wd - currentWeekStart.getDay()));
                        while (candidate < currentWeekStart) candidate = addDays(candidate, 7);
                        while (candidate > addDays(currentWeekStart, 6)) candidate = addDays(candidate, -7);
                        if (candidate < baseDate) return;
                        if (candidate > endDate) { stop = true; return; }
                        if (recEnd && candidate > recEnd) { stop = true; return; }
                        if (recCount && count >= recCount) { stop = true; return; }

                        if (isExceptionDate(candidate)) return;
                        if (candidate >= startDate && candidate <= endDate) {
                            occurrences.push(Object.assign({}, evt, { occurrence_date: formatYMD(candidate) }));
                            count++;
                        }
                    });

                    if (stop) break;
                    currentWeekStart = addDays(currentWeekStart, 7 * interval);
                    if (currentWeekStart > endDate || (recEnd && currentWeekStart > recEnd)) break;
                    if (recCount && count >= recCount) break;
                    weekIndex++;
                    if (weekIndex > 10000) break;
                }
            } else if (rec === 'monthly') {
                var dayOfMonth = baseDate.getDate();
                var cur = cloneDate(baseDate);
                while (cur < startDate) cur = addMonths(cur, interval);
                var iter = 0;
                while (cur <= endDate) {
                    if (recEnd && cur > recEnd) break;
                    if (recCount && count >= recCount) break;
                    var dim = daysInMonth(cur.getFullYear(), cur.getMonth());
                    var candidate = new Date(cur.getFullYear(), cur.getMonth(), Math.min(dayOfMonth, dim));
                    if (candidate >= baseDate) {
                        if (!isExceptionDate(candidate)) {
                            if (candidate >= startDate && candidate <= endDate) {
                                occurrences.push(Object.assign({}, evt, { occurrence_date: formatYMD(candidate) }));
                                count++;
                            }
                        }
                    }
                    iter++;
                    if (iter > 1200) break;
                    cur = addMonths(cur, interval);
                }
            } else {
                if (baseDate >= startDate && baseDate <= endDate && !isExceptionDate(baseDate)) {
                    occurrences.push(Object.assign({}, evt, { occurrence_date: formatYMD(baseDate) }));
                }
            }
        });

        return occurrences;
    }

    function groupOccurrencesByDate(occurrences) {
        var map = {};
        occurrences.forEach(function (o) {
            var d = o.occurrence_date;
            map[d] = map[d] || [];
            map[d].push(o);
        });
        return map;
    }

    // Helper: ensure stripe heights match rendered boxes
    function adjustStripes(container) {
        // wait for layout; double rAF to be safe
        requestAnimationFrame(function () {
            requestAnimationFrame(function () {
                var events = (container || document).querySelectorAll('.shop-cal-event');
                events.forEach(function (ev) {
                    var stripe = ev.querySelector('.shop-cal-event-color');
                    if (!stripe) return;
                    // measure the event box height
                    var h = ev.clientHeight || Math.ceil(ev.getBoundingClientRect().height);
                    if (h && h > 0) {
                        stripe.style.height = h + 'px';
                        stripe.style.display = 'block';
                    } else {
                        // fallback fixed min height
                        stripe.style.minHeight = '40px';
                    }
                });
            });
        });
    }

    // Main init function
    window.initShopifyCalendar = function (elementId, opts) {
        opts = opts || {};
        var el = document.getElementById(elementId);
        if (!el) return;
        var events = opts.events || [];
        var weekStart = Number(opts.weekStart || 0) || 0;
        var windowMonths = Number(opts.recurrenceWindowMonths || opts.windowMonths || 12) || 12;
        var pastMonths = Number(opts.recurrencePastMonths) || 3;
        if (isNaN(pastMonths)) pastMonths = Number(el.dataset.pastMonths) || 3;
        if (isNaN(windowMonths)) windowMonths = Number(el.dataset.windowMonths) || 12;

        // no type filter UI/logic
        var showTypeFilter = false;

        events = (events || []).map(function (e) {
            var copy = Object.assign({}, e);
            copy.date = (e.date && typeof e.date === 'string') ? e.date : (e.date ? formatYMD(parseYMD(e.date)) : null);
            return copy;
        });

        var today = new Date();
        var startDate = addMonths(today, -Math.max(0, pastMonths));
        startDate = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
        var endDate = addMonths(today, Math.max(0, windowMonths));
        endDate = new Date(endDate.getFullYear(), endDate.getMonth(), daysInMonth(endDate.getFullYear(), endDate.getMonth()));

        var occurrences = expandRecurrences(events, startDate, endDate);
        var byDate = groupOccurrencesByDate(occurrences);

        var left = el.querySelector('.calendar-left');
        var right = el.querySelector('.calendar-right');
        left.innerHTML = '';
        right.innerHTML = '';

        var selectedDate = formatYMD(today);
        var currentMonth = new Date(today.getFullYear(), today.getMonth(), 1);

        function render() {
            left.innerHTML = '';
            right.innerHTML = '';

            var header = document.createElement('div');
            header.className = 'shop-cal-header';

            var nav = document.createElement('div');
            nav.className = 'shop-cal-nav';

            var prevBtn = document.createElement('button');
            prevBtn.type = 'button';
            prevBtn.className = 'shop-cal-nav-btn';
            prevBtn.innerText = '‹';
            prevBtn.addEventListener('click', function () { currentMonth = addMonths(currentMonth, -1); render(); });

            var nextBtn = document.createElement('button');
            nextBtn.type = 'button';
            nextBtn.className = 'shop-cal-nav-btn';
            nextBtn.innerText = '›';
            nextBtn.addEventListener('click', function () { currentMonth = addMonths(currentMonth, +1); render(); });

            var title = document.createElement('div');
            title.className = 'shop-cal-title';
            var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
            title.innerText = monthNames[currentMonth.getMonth()] + ' ' + currentMonth.getFullYear();

            nav.appendChild(prevBtn);
            nav.appendChild(title);
            nav.appendChild(nextBtn);
            header.appendChild(nav);

            left.appendChild(header);

            var grid = document.createElement('table');
            grid.className = 'shop-cal-grid';
            var thead = document.createElement('thead');
            var tr = document.createElement('tr');
            var weekdayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
            for (var w = 0; w < 7; w++) {
                var th = document.createElement('th');
                th.innerText = weekdayNames[(w + weekStart) % 7];
                tr.appendChild(th);
            }
            thead.appendChild(tr);
            grid.appendChild(thead);

            var tbody = document.createElement('tbody');
            var monthStart = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), 1);
            var startWeekday = (monthStart.getDay() - weekStart + 7) % 7;
            var days = daysInMonth(currentMonth.getFullYear(), currentMonth.getMonth());
            var rows = Math.ceil((startWeekday + days) / 7);
            var dayCounter = 1 - startWeekday;
            for (var r = 0; r < rows; r++) {
                var trBody = document.createElement('tr');
                for (var c = 0; c < 7; c++) {
                    var td = document.createElement('td');
                    td.className = 'shop-cal-cell';
                    if (dayCounter >= 1 && dayCounter <= days) {
                        var cellDate = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), dayCounter);
                        var ymd = formatYMD(cellDate);
                        td.dataset.ymd = ymd;
                        td.classList.add('shop-cal-day');

                        var num = document.createElement('div');
                        num.className = 'shop-cal-day-num';
                        num.innerText = dayCounter;
                        td.appendChild(num);

                        var dayEvents = byDate[ymd] || [];

                        if (dayEvents.length) {
                            var dots = document.createElement('div');
                            dots.className = 'shop-cal-dots';
                            // show up to 5 dots (no uniqueness filter so multiple events of same type show separately)
                            dayEvents.slice(0, 5).forEach(function (de) {
                                var dot = document.createElement('span');
                                dot.className = 'shop-cal-dot';
                                dot.style.backgroundColor = de.color || '#2563eb';
                                dot.title = de.title || '';
                                dots.appendChild(dot);
                            });
                            td.appendChild(dots);
                        }

                        var todayYMD = formatYMD(new Date());
                        if (ymd === todayYMD) td.classList.add('shop-cal-today');
                        if (ymd === selectedDate) td.classList.add('shop-cal-selected');

                        td.addEventListener('click', function (ev) {
                            var newYmd = ev.currentTarget.dataset.ymd;
                            selectedDate = newYmd;
                            var parts = newYmd.split('-'); var dObj = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
                            currentMonth = new Date(dObj.getFullYear(), dObj.getMonth(), 1);
                            render();
                        });
                    } else {
                        td.classList.add('shop-cal-empty');
                    }
                    trBody.appendChild(td);
                    dayCounter++;
                }
                tbody.appendChild(trBody);
            }
            grid.appendChild(tbody);
            left.appendChild(grid);

            // Right side — day details
            var detailWrap = document.createElement('div');
            detailWrap.className = 'shop-cal-details';
            var selTitle = document.createElement('div');
            selTitle.className = 'shop-cal-day-title';
            var selDateObj = parseYMD(selectedDate);
            var optsTitle = { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' };
            selTitle.innerText = selDateObj ? selDateObj.toLocaleDateString(undefined, optsTitle) : selectedDate;
            detailWrap.appendChild(selTitle);

            var detailList = document.createElement('div');
            detailList.className = 'shop-cal-event-list';
            var dayEvents = byDate[selectedDate] || [];

            if (!dayEvents.length) {
                var none = document.createElement('div');
                none.className = 'shop-cal-no-events';
                none.innerText = 'No events';
                detailList.appendChild(none);
            } else {
                dayEvents.sort(function (a, b) {
                    var ta = a.time || '';
                    var tb = b.time || '';
                    return (ta < tb) ? -1 : (ta > tb) ? 1 : 0;
                });

                dayEvents.forEach(function (de) {
                    var evWrap = document.createElement('div');
                    evWrap.className = 'shop-cal-event';
                    var colorMark = document.createElement('div');
                    colorMark.className = 'shop-cal-event-color';
                    colorMark.style.backgroundColor = de.color || '#2563eb';
                    evWrap.appendChild(colorMark);

                    var content = document.createElement('div');
                    content.className = 'shop-cal-event-content';

                    var h = document.createElement('div');
                    h.className = 'shop-cal-event-head';
                    var tit = document.createElement('div');
                    tit.className = 'shop-cal-event-title';
                    tit.innerText = de.title || '(Untitled)';
                    h.appendChild(tit);
                    if (de.time) {
                        var timeEl = document.createElement('div');
                        timeEl.className = 'shop-cal-event-time';
                        timeEl.innerText = de.time;
                        h.appendChild(timeEl);
                    }
                    content.appendChild(h);

                    if (de.description) {
                        var desc = document.createElement('div');
                        desc.className = 'shop-cal-event-desc';
                        desc.innerText = de.description;
                        content.appendChild(desc);
                    }

                    if (de.url) {
                        var link = document.createElement('a');
                        link.className = 'shop-cal-event-link';
                        link.href = de.url;
                        link.target = '_blank';
                        link.rel = 'noopener noreferrer';
                        link.innerText = de.url_text || de.url || 'Open';
                        content.appendChild(link);
                    }

                    evWrap.appendChild(content);
                    detailList.appendChild(evWrap);
                });
            }

            right.appendChild(detailWrap);
            right.appendChild(detailList);

            // adjust stripe heights after render
            adjustStripes(detailList);
        }

        render();
    };
})();